import './NextButton.css';

function NextButton(props:{
    buttonTitle: string | undefined,
    onClick: () => void,
    disabled: boolean
}){
    return(
        <button className='next-button' onClick={props.onClick} disabled={props.disabled}>
            {props.buttonTitle}
        </button>
    )
}

export default NextButton;